/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../TheCage";
import {TheCageSound} from "../../sound/TheCageSound";
import {TheCageGameMode} from "../../server/TheCageGameMode";
import {GloveSymbol} from "../../reels/freespins/GloveSymbol";
import {GSAPUtils} from "../../utils/GSAPUtils";


export class FreeSpinHitOpponentPresentation implements SimplePresentation {
    name:string = "FreeSpinHitOpponentPresentation";

    constructor() {
    }

    shouldRun():boolean {
        const fsLevel = TheCage.model.data.fsLevel;
        const bnCount = TheCage.model.data.nBNcollectedInFSAfter[fsLevel]
                        - TheCage.model.data.nBNcollectedInFSBefore[fsLevel];
        return (TheCage.model.data.nextMode == TheCageGameMode.FREESPIN ||
                TheCage.model.data.nextMode == TheCageGameMode.NORMAL) &&
               (bnCount > 0 || TheCage.model.data.fsLevel == 4) &&
               !TheCage.model.gameData.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => {
                controller.finish();
            }});
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2) ;
        }));

        const fsLevel = TheCage.model.data.fsLevel;
        const bnCount = TheCage.model.data.nBNcollectedInFSAfter[fsLevel]
                        - TheCage.model.data.nBNcollectedInFSBefore[fsLevel];
        if (bnCount > 0) {
            const bnSymbols = TheCage.freeSpinReelView.avalancheMatrixModel.getAllSymbolsWithName("BN");
            const punchTls:gsap.core.Timeline[] = [];
            for (let i = 0; i < bnCount; i++) {
                const punchTl = gsap.timeline();
                punchTl.add(() => {TheCage.soundPlayer.playSound(TheCageSound.FS_PUNCH_SWEEP)});
                punchTl.add((<GloveSymbol>bnSymbols[i].positionable).getPunchAnimation());
                punchTl.add(TheCage.freeSpinReelView.opponent.getPunched(1), '<0.41');
                punchTl.add(TheCage.freeSpinReelView.opponentCounter.tickDown(1), '<');
                punchTls.push(punchTl);
            }
            tl.add(GSAPUtils.createTimelineFromArray(punchTls), '<0.2')
        }
    }
}
